import React from 'react';
import Log from '../../../models/Log';
import Pagination from '../../../models/Pagination';
import { Table, TableBody, TableCell, TableHead, TableRow, CircularProgress, Paper } from  '@mui/material';
import PaginationButtons from '../../PaginationButtons';
import { ISTableTitle, ISTableHeaderCell, ISTableRow } from '../../Utils/ISTable';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { personTypeToDescription } from '../../Client/Profile';

export interface Row {
  data: Log
  action?: 'create' | 'update' | 'error';
}

interface Props {
  rows: Row[];
  loading: boolean;
  pagination?: Pagination;
  onChangePage?: (page: number) => void;
  onClickInfo?: (codigo_loge: number) => void;
}

const Logs: React.FC<Props> = (props) => {  
  const { t } = useTranslation(['log', 'person'])

  const mapActionToColor = (action?: string) => {
    switch (action) {
      case 'create': return 'green';
      case 'update': return 'yellow';
      case 'error': return 'red';
      default: return 'default';
    }
  }

  const translatePersonTypeDescription = (value: string): string => t(personTypeToDescription(value), { ns: 'person' })

  return (
    <Paper style={{borderRadius: "10px", margin:"10px"}}>
      <ISTableTitle title={t('title')}/> 
      <Table style={{whiteSpace:"nowrap", overflow:"hidden"}} size="medium" >
        <TableHead>
          <TableRow selected={true}>
            <ISTableHeaderCell align='center'>{t('date')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('name')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('role')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('action')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('info')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('byPersonTypeId')}</ISTableHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          { !props.loading && props.rows.map((row, index) =>
            <ISTableRow key={index} color={mapActionToColor(row.action)} sx={{cursor: 'pointer'}}
                  onClick={(e) => { e.stopPropagation(); props.onClickInfo && props.onClickInfo(row.data.id) }}>
              <TableCell align='center'>{moment(row.data.date).tz("America/Argentina/Buenos_Aires").format('DD/MM/YYYY HH:mm')}</TableCell>
              <TableCell>{row.data.person?.fullName}</TableCell>
              <TableCell>{translatePersonTypeDescription(row.data.role)}</TableCell>
              <TableCell>{t(`${row.data.action}`)}</TableCell>
              <TableCell>{row.data.info}</TableCell>
              <TableCell>{row.data.person?.byPersonTypeId}</TableCell>
            </ISTableRow>
          )}
        </TableBody>
      </Table>
      { props.loading &&
        <div style={{display:'flex', justifyContent:'center'}}>
          <CircularProgress size={25} />
        </div>
      }
      <PaginationButtons pagination={props.pagination} />
    </Paper>
  );
}

export default Logs

